(() => {
  // assets/scripts/collective-hero.ts
  class CollectiveHero extends HTMLElement {
    modal = null;
    connectedCallback() {
      this.modal = this.querySelector("[data-collective-modal]");
      if (!this.modal) return;
      if (this.modal.parentElement !== document.body) {
        document.body.appendChild(this.modal);
      }
      const closers = this.modal.querySelectorAll(
        "[data-collective-modal-close]",
      );
      for (const closer of closers) {
        closer.addEventListener("click", () => this.close());
      }
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") this.close();
      });
    }
    open() {
      if (!this.modal) return;
      this.modal.setAttribute("data-open", "");
      this.modal.setAttribute("aria-hidden", "false");
    }
    close() {
      if (!this.modal) return;
      this.modal.removeAttribute("data-open");
      this.modal.setAttribute("aria-hidden", "true");
    }
  }
  if (!customElements.get("collective-hero")) {
    customElements.define("collective-hero", CollectiveHero);
  }
})();
